import {SpaceProto} from "../space-proto";
import ProjectSession from "../../project/project-session";
import {ProjectsTreeSortType} from "../@types";


export default function space_getSorting(space:SpaceProto):ProjectsTreeSortType {

    const userSorting = gd.user.settings.navigation.spacesPreferences[space.id]?.projectsSorting

    if (userSorting) {
        return userSorting
    }

    // otherwise need default

    // customer portal defaults to sortPosition/manually, but customers can still switch to A-Z above
    if (gd.user.acl.isClient) {
        return ProjectsTreeSortType.MANUAL_OLD
    }

    // check if project has it set !
    if (space.isWorkspace || space.isSection) {

        // @ts-ignore
        const project: ProjectSession = space.project

        if (project.properties.defaultSorting) {
            return project.properties.defaultSorting
        }

    }

    // default failback ... in future should be manual but dunno how to set it for new projects only
    // need date created in projectSession ?
    return ProjectsTreeSortType.ALPHABETICAL


}